export default function CompanyInfo() {
  const companyData: { label: string; value: string; isEmail?: boolean }[] = [
    { label: '会社名', value: '株式会社C.GREEN' },
    { label: '設立', value: '2014年7月31日' },
    { label: '資本金', value: '41,500,000円' },
    { label: 'お問い合わせ', value: 'c.green.support@gmail.com', isEmail: true }
  ];

  const offices = [
    {
      name: '本社',
      address: '山口県下関市長府浜浦南町5-28'
    },
    {
      name: 'つくば事務所',
      address: '茨城県つくば市天久保3-10-7'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16">
          {/* 基本情報 */}
          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-8">会社情報</h2>
            <div className="space-y-6">
              {companyData.map((item, index) => (
                <div key={index} className="border-b border-gray-200 pb-4">
                  <dt className="text-sm font-medium text-gray-500 mb-2">{item.label}</dt>
                  <dd className="text-lg text-gray-900">
                    {item.isEmail ? (
                      <a
                        href={`mailto:${item.value}`}
                        className="text-[#2D6E4E] hover:underline cursor-pointer"
                      >
                        {item.value}
                      </a>
                    ) : (
                      item.value
                    )}
                  </dd>
                </div>
              ))}
            </div>
          </div>

          {/* 事業所 */}
          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-8">事業所</h2>
            <div className="space-y-8">
              {offices.map((office, index) => (
                <div key={index} className="bg-gray-50 rounded-lg p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{office.name}</h3>
                  <p className="text-gray-700 leading-relaxed">{office.address}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}